let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7rQZA")).then(() => parcelRequire('61q45'));